import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { GlobalService } from "../../services/global.service";
import * as use from '@tensorflow-models/universal-sentence-encoder';
var NlpSentenceEncoderComponent = /** @class */ (function () {
    function NlpSentenceEncoderComponent(service) {
        this.service = service;
        this.list_sentences = [];
        this.plotly_heatmap = { data: [], layout: {} };
    }
    NlpSentenceEncoderComponent.prototype.ngOnInit = function () {
        this.service.changePageTitle('Sentence Similarity With TensorFlow.Js Sentence Encoder');
        this.input_sentences =
            "Will it snow tomorrow?\nRecently a lot of hurricanes have hit the US\nGlobal warming is real\n\nAn apple a day, keeps the doctors away\nEating strawberries is healthy\n\nwhat is your age?\nHow old are you?\nHow are you?\n\nThe dog bit Johnny\nJohnny bit the dog\n\nThe cat ate the mouse\nThe mouse ate the cat\n";
        this.input_threshold = 0.5;
        this.onClickAnalyzeSentences();
    };
    NlpSentenceEncoderComponent.prototype.onClickAnalyzeSentences = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var list_sentences, input_sentences, i;
            return tslib_1.__generator(this, function (_a) {
                list_sentences = [];
                input_sentences = this.input_sentences.split("\n");
                for (i in input_sentences) {
                    if (input_sentences[i].length) {
                        list_sentences.push(input_sentences[i]);
                    }
                }
                console.log(list_sentences);
                this.get_similarity(list_sentences);
                return [2 /*return*/];
            });
        });
    };
    NlpSentenceEncoderComponent.prototype.get_embeddings = function (list_sentences, callback) {
        use.load().then(function (model) {
            model.embed(list_sentences).then(function (embeddings) {
                callback(embeddings);
            });
        });
    };
    NlpSentenceEncoderComponent.prototype.dot = function (a, b) {
        var hasOwnProperty = Object.prototype.hasOwnProperty;
        var sum = 0;
        for (var key in a) {
            if (hasOwnProperty.call(a, key) && hasOwnProperty.call(b, key)) {
                sum += a[key] * b[key];
            }
        }
        return sum;
    };
    NlpSentenceEncoderComponent.prototype.similarity = function (a, b) {
        var magnitudeA = Math.sqrt(this.dot(a, a));
        var magnitudeB = Math.sqrt(this.dot(b, b));
        if (magnitudeA && magnitudeB)
            return this.dot(a, b) / (magnitudeA * magnitudeB);
        else
            return false;
    };
    NlpSentenceEncoderComponent.prototype.cosine_similarity_matrix = function (matrix) {
        var cosine_similarity_matrix = [];
        for (var i = 0; i < matrix.length; i++) {
            var row = [];
            for (var j = 0; j < i; j++) {
                row.push(cosine_similarity_matrix[j][i]);
            }
            row.push(1);
            for (var j = (i + 1); j < matrix.length; j++) {
                row.push(this.similarity(matrix[i], matrix[j]));
            }
            cosine_similarity_matrix.push(row);
        }
        return cosine_similarity_matrix;
    };
    NlpSentenceEncoderComponent.prototype.form_groups = function (cosine_similarity_matrix) {
        var dict_keys_in_group = {};
        var groups = [];
        for (var i_1 = 0; i_1 < cosine_similarity_matrix.length; i_1++) {
            var this_row = cosine_similarity_matrix[i_1];
            for (var j = i_1; j < this_row.length; j++) {
                if (i_1 != j) {
                    var sim_score = cosine_similarity_matrix[i_1][j];
                    if (sim_score > this.input_threshold) {
                        var group_num = void 0;
                        if (!(i_1 in dict_keys_in_group)) {
                            group_num = groups.length;
                            dict_keys_in_group[i_1] = group_num;
                        }
                        else {
                            group_num = dict_keys_in_group[i_1];
                        }
                        if (!(j in dict_keys_in_group)) {
                            dict_keys_in_group[j] = group_num;
                        }
                        if (groups.length <= group_num) {
                            groups.push([]);
                        }
                        groups[group_num].push(i_1);
                        groups[group_num].push(j);
                    }
                }
            }
        }
        var return_groups = [];
        for (var i in groups) {
            return_groups.push(Array.from(new Set(groups[i])));
        }
        console.log(return_groups);
        return return_groups;
    };
    NlpSentenceEncoderComponent.prototype.get_similarity = function (list_sentences) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var callback, embeddings;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        callback = function (embeddings) {
                            // console.log("embeddings", embeddings);
                            var cosine_similarity_matrix = this.cosine_similarity_matrix(embeddings.arraySync());
                            console.log(cosine_similarity_matrix);
                            var groups = this.form_groups(cosine_similarity_matrix);
                            var html_groups = "";
                            for (var i in groups) {
                                html_groups += "<br/><b>Group " + String(parseInt(i) + 1) + "</b><br/>";
                                for (var j in groups[i]) {
                                    // console.log(groups[i][j], list_sentences[ groups[i][j] ])
                                    html_groups += list_sentences[groups[i][j]] + "<br/>";
                                }
                            }
                            this.output_resultshtml = html_groups;
                            // plot heatmap
                            var colors = [];
                            var base_color = 54;
                            for (var i = 0; i <= 10; i++) {
                                colors.push([i / 10, "rgb(0," + (base_color + (i * 20)) + ",0)"]);
                            }
                            this.plotly_heatmap = {
                                data: [
                                    {
                                        z: cosine_similarity_matrix,
                                        x: list_sentences,
                                        y: list_sentences,
                                        type: 'heatmap',
                                        colorscale: colors
                                    }
                                ],
                                layout: { height: 1200, title: "Similarity", autosize: true },
                            };
                            this.analyzing_text = false;
                        };
                        this.analyzing_text = true;
                        return [4 /*yield*/, this.get_embeddings(list_sentences, callback.bind(this))];
                    case 1:
                        embeddings = _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return NlpSentenceEncoderComponent;
}());
export { NlpSentenceEncoderComponent };
